import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { listPoolOffers, type ApiClient, type PoolOfferListItem } from '../../modules/api';
import { Image } from '../../modules/design-system';

export function Lobby({ client, onSelect }: { client: ApiClient; onSelect: (offerId: string) => void }) {
  const [offers, setOffers] = useState<PoolOfferListItem[] | null>(null);

  useEffect(() => {
    let cancelled = false;
    void listPoolOffers(client)
      .then((data) => { if (!cancelled) setOffers(data); })
      .catch((err) => { toast.error('Failed to load games: ' + (err as Error).message); });
    return () => { cancelled = true; };
  }, [client]);

  if (!offers) return <div className="p-8">Loading offers…</div>;
  if (offers.length === 0) return <div className="p-8">No games available</div>;

  return (
    <div className="grid grid-cols-2 gap-4 p-8 md:grid-cols-3">
      {offers.map((offer) => (
        <button
          key={offer.id}
          type="button"
          onClick={() => onSelect(String(offer.id))}
          className="rounded border border-gp-border bg-gp-bg p-4 transition-transform hover:scale-105"
        >
          <Image
            src={offer.packImageUrl ?? ''}
            alt={offer.title}
            className="mb-2 aspect-[4/3] w-full rounded"
            imgClassName="absolute inset-0 h-full w-full object-cover"
            width={240}
            height={180}
          />
          <div className="font-semibold">{offer.title}</div>
          <div className="text-sm opacity-70">${Number(offer.price).toFixed(2)}</div>
        </button>
      ))}
    </div>
  );
}
